<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.transferStatus"
    item-text="name"
    item-value="id"
    label="Transfer Status"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.transferStatus)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      {
        id: 'Pending',
        name: 'Pending',
      },
      {
        id: 'Completed',
        name: 'Completed',
      },
      {
        id: 'Canceled',
        name: 'Cancelled',
      },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_TRANSFER_STATUS_FILTER', data);

      this.$emit('input', this.filterDatas.transferStatus);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.transferStatus);
  },
};
</script>
